export default __webpack_public_path__ + "static/media/longheaderblue.428afc34.png";